import { render, staticRenderFns } from "./SalesChartV2.vue?vue&type=template&id=05bab92e"
import script from "./SalesChartV2.vue?vue&type=script&lang=js"
export * from "./SalesChartV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports